import LZString from "lz-string";

import { FeatureGateOverrideValues } from "../feature-gates/types";

export const getExperimentOverrides = (
    parsedRequestCookies: Record<string, string | undefined>
): FeatureGateOverrideValues => {
    const expOverride = "atlassian_exp_overrides";
    for (const cookieKey of Object.keys(parsedRequestCookies)) {
        if (cookieKey === expOverride && parsedRequestCookies[expOverride]) {
            return decompressCookie(parsedRequestCookies[expOverride]);
        }
    }
    return {}; // return empty overrides if none are found
};

export const getFeatureGateOverrides = (
    parsedRequestCookies: Record<string, string>
): FeatureGateOverrideValues => {
    const fgOverride = "atlassian_feature_gate_overrides";
    for (const cookieKey of Object.keys(parsedRequestCookies)) {
        if (cookieKey === fgOverride && parsedRequestCookies[fgOverride]) {
            return decompressCookie(parsedRequestCookies[fgOverride]);
        }
    }
    return {}; // return empty overrides if none are found
};

export const decompressCookie = (cookie: string) => {
    try {
        return JSON.parse(LZString.decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};
